const GO_TO_ROUTE_EVENTS = {
    FETCH_SUCCESS: 'FETCH_SUCCESS',
    FETCH_FAILURE: 'FETCH_FAILURE',
  };
  
  export {  GO_TO_ROUTE_EVENTS };